var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLicenseCreator = function SvgLicenseCreator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DF5C2",
    d: "m.74 14.18 1.684-2.908L8.74 13.04v3.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E59B",
    d: "m16.74 14.18-1.682-2.908L8.74 13.04v3.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A94FF",
    d: "m3.043 10.227 1.949-3.372 3.775 1.09v3.85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#477BFF",
    d: "M14.436 10.184 12.493 6.89 8.766 7.949v3.844z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7881",
    d: "M8.715 6.6V.44c-.4 0-.463.215-.714.624-.1.162-2.641 4.552-2.641 4.552z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6973",
    d: "M8.716 6.6V.44c.4 0 .463.215.714.624.1.162 2.64 4.552 2.64 4.552z"
  })));
};
export default SvgLicenseCreator;